export default {
    'nav.news.detai.title':'详情',
    'asset.stock.purchare.detail.add.optional':'添加自选成功',
    'asset.stock.purchare.detail.delete.optional':'移除自选成功',
    'news.days.ago':'天前',
    'news.hours.ago':'小时前',
    'news.minutes.ago':'分钟前',
    'news.seconds.ago':'秒前',
}